const Mark = ({ className, bg }) => (
  <svg viewBox="0 0 64 64" className={className} aria-hidden="true">
    {bg && <rect width="64" height="64" rx="12" fill="#0D0D0E" />}
    <path d="M10 56V25L32 9l22 16v31z" fill="none" stroke="#D4A73C" strokeWidth="2" strokeLinejoin="miter" />
    <path d="M15 56V28L32 15.5 49 28v28" fill="none" stroke="#D4A73C" strokeWidth="0.8" opacity=".55" />
    <text x="32" y="51" textAnchor="middle" fontFamily="'Cormorant Garamond', Georgia, serif" fontSize="34" fontStyle="italic" fill="#E8C063">S</text>
  </svg>
);

export const LogoMark = ({ className = "w-10 h-10" }) => <Mark className={className} />;

export const Logo = () => (
  <span className="flex items-center gap-3">
    <LogoMark />
    <span className="leading-none text-left">
      <span className="font-display text-xl tracking-wide block text-[#f4f1ea]">Slusariuc</span>
      <span className="text-[10px] tracking-[0.42em] uppercase text-[#d4a73c]">Costruzioni</span>
    </span>
  </span>
);
